import React, { CSSProperties } from 'react';
import { MODELS } from '../content';
import { Stage, stageClass } from '../motion';

// The four sizes nested from one corner, like paper sizes, largest first; the column's own
// size is drawn in ink and traces its outline when the row is revealed.

const W = 200;
const H = 96;
const RATIO = Math.SQRT2;
const WIDTHS = [128, 128 / RATIO, 128 / 2, 128 / (2 * RATIO)];

export function SizeNest({ index, stage, delay }: { index: number; stage: Stage; delay: number }) {
  return (
    <svg className={`oh-fig oh-nest ${stageClass(stage)}`} viewBox={`0 0 ${W} ${H}`} style={{ maxWidth: W }} aria-hidden="true">
      {MODELS.map((model, i) => {
        const w = WIDTHS[i];
        const h = w / RATIO;
        const own = i === index;
        return (
          <rect
            key={model.id}
            className={own ? 'oh-nest-own' : 'oh-hair'}
            x={0.75}
            y={H - 0.75 - h}
            width={w}
            height={h}
            style={own ? ({ '--d': `${delay}s`, '--len': (2 * (w + h)).toFixed(1) } as CSSProperties) : undefined}
          />
        );
      })}
    </svg>
  );
}

export default SizeNest;
